import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderModal', {
  orderTime: 'Hora de pedido',
  storeName: 'Tienda',
  order: 'Pedido',
  orderSummary: 'Resumen pedido'
});
